import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ReactDOM from 'react-dom';
class EditorReactView {
  constructor(component, reactComponentProps, node, view, getPos, wrapType, pluginOptions) {
    var _node$attrs;
    this._init = () => {
      this._renderComponent();
    };
    this._renderComponent = () => {
      const ReactComponent = this.component;
      ReactDOM.render( /*#__PURE__*/React.createElement(ReactComponent, _extends({}, this.node.attrs, this.reactComponentProps, {
        view: this.view,
        pluginOptions: this.pluginOptions
      })), this.dom);
    };
    this._createDom = () => {
      if (this.wrapType === 'inline') {
        return document.createElement('span');
      }
      if (this.wrapType === 'inline-block') {
        const span = document.createElement('span');
        span.setAttribute('style', 'display:inline-block');
        return span;
      }
      return document.createElement('div');
    };
    this.node = node;
    this.view = view;
    this.getPos = getPos;
    this.component = component;
    this.reactComponentProps = reactComponentProps;
    this.wrapType = wrapType || ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.wrapType);
    this.pluginOptions = pluginOptions || {};
    this.dom = this._createDom();
    this._init();
  }
  update(node) {
    if (!node.sameMarkup(this.node)) return false;
    this.node = node;
    this._renderComponent();
    return true;
  }
  ignoreMutation() {
    return true;
  }
}
export default EditorReactView;